// export const BASE_URL = 'https://api.chainalysis.credit/api/'
// export const BASE_URL = 'https://backend.geminiltd.online/api/';
export const BASE_URL = 'https://backend.thetrademarkets.com/api/';
// export const BASE_URL = 'https://backendcrypto.developer-ma.com/api/';
// export const BASE_URL = 'https://staggingbackend.thetrademarkets.com/api/';
